<template>
  <div class="">

    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <h3>لیست کاربران اشتراک</h3>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-lg-9">
              <form @submit.prevent="submitSearch">
                <div class="row">
                  <b-form-input
                      v-model="searchWord"
                      placeholder="جستجو از طریق نام، نام خانوادگی، شماره تلفن"
                      class="col-lg-4"
                  ></b-form-input>
                  <b-button
                      @click="submitSearch"
                      variant="primary"
                      class="mr-2"
                  >
                    جستجو
                  </b-button>
                </div>
              </form>
            </div>
            <div class="col-lg-3 text-left">
              <button class="btn btn-primary mx-1 rounded-pill" v-b-modal.create-manual-subscription>افزودن اشتراک
              </button>

              <router-link :to="{name:'SubscriptionChargesFilter'}">
                <button class="btn btn-primary mx-1 rounded-pill">فیلتر</button>
              </router-link>


              <b-modal size="lg" id="create-manual-subscription" hide-footer>
                <div class="text-right" dir="rtl">
                  <create-manual-subscription-charge @loadItems="loadSubscriptionCharges"/>
                </div>
              </b-modal>

            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="table my-3 table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
      <thead>
      <tr>
        <th>شناسه</th>
        <th>کاربر</th>
        <th>اشتراک ها</th>
      </tr>
      </thead>

      <tr v-for="user in subscriptionsCharges">
        <th>{{ user.id }}</th>
        <th>{{ user.name }} {{ user.last_name }}</th>
        <th>
          <div class="my-3" v-for="subscriptionCharge in user.subscription_charge">
            <div class="row align-items-start justify-content-around">
              <div class="  my-2 col-sm-12 col-lg-auto col-md-12 text-center">
                <span class="col-sm-12 col-lg-auto col-md-12">{{
                    subscriptionCharge.subscription.name
                  }} - {{ subscriptionCharge.subscriptionItem.name }}</span>
              </div>

              <span dir="ltr" class="  my-2 btn btn-primary btn-sm rounded-pill">{{
                  subscriptionChargeValueManager(subscriptionCharge)
                }}</span>

              <div class="  my-2 col-lg-auto col-md-12 text-center col-sm-12">
                <b-icon-clock-history v-b-modal="`subscription-charge-history-${subscriptionCharge.id}`"
                                      class="h5 mx-2 "/>

                <b-icon-pencil-square v-b-modal="`subscription-charge-${subscriptionCharge.id}`" class="h5 mx-2 "/>
                <b-icon-trash @click="removeSubscription(subscriptionCharge)" class="h5 mx-2 "/>
              </div>

            </div>

            <hr>


            <b-modal size="lg" :id="`subscription-charge-${subscriptionCharge.id}`" hide-footer>
              <div class="text-right" dir="rtl">
                <charge-subscription @reloadItems="loadSubscriptionCharges" :subscription-charge="subscriptionCharge"/>
              </div>
            </b-modal>


            <b-modal size="lg" :id="`subscription-charge-history-${subscriptionCharge.id}`" hide-footer>
              <div class="text-right" dir="rtl">
                <subscription-charge-history :subscription-charge="subscriptionCharge"/>
              </div>
            </b-modal>

          </div>
        </th>


      </tr>
    </table>

    <div class="row justify-content-center pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from "../../components/dashboard/Pagination.vue";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import SubscriptionChargeHistory from "../../components/dashboard/SubscriptionCharge/SubscriptionChargeHistory.vue";
import ChargeSubscription from "../../components/dashboard/SubscriptionCharge/ChargeSubscription.vue";
import CreateManualSubscriptionCharge
  from "../../components/dashboard/SubscriptionCharge/CreateManualSubscriptionCharge.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "SubscriptionCharge",
  components: {CreateManualSubscriptionCharge, ChargeSubscription, SubscriptionChargeHistory, Pagination},
  data() {
    return {
      subscriptionsCharges: [],
      paginationMeta: [],
      searchWord: ''
    }
  },
  methods: {
    loadSubscriptionCharges(page = 1) {
      let req = this.$store.dispatch('SubscriptionCharge/getSubscriptionCharges', page)
      document.querySelectorAll('.modal.show').forEach(modal => {
        this.$bvModal.hide(modal.id);
      });
      req.then((res) => {
        let data = res.data.data
        this.subscriptionsCharges = data.data
        this.paginationMeta = data.meta

      })
    },
    changePage(page) {
      this.loadSubscriptionCharges(page)
    },
    subscriptionChargeValueManager(subscriptionCharge) {
      let value = subscriptionCharge.value
      if (subscriptionCharge.subscription.value_type == 'date') {
        return dateConverter(value, '/', true)
      }
      return value
    },
    submitSearch() {
      this.$store.commit('SubscriptionCharge/setFilters', {key: 'search', value: this.searchWord})
      this.loadSubscriptionCharges()
    },
    removeSubscription(item) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch('SubscriptionCharge/deleteSubscriptionCharges', item).then((res) => {
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
          this.loadSubscriptionCharges()
        })
      }
    }
  },
  mounted() {
    this.loadSubscriptionCharges()
  }
}
</script>

<style scoped>
.table tr:nth-child(odd) {
  background: white;
}
</style>